import React, { useState } from 'react';
import { PrimaryButton, SecondaryButton } from '../../components/Buttons/Buttons';
import { WarningAlertIcon } from '../../Icons/AlertIcons/AlertIcons';
import { LOG_COLLECTION_DIALOG_STRINGS } from '../../pages/SupportAndTroubleshoot/SupportAndTroubleshootStrings';
import './LogCollectionDialog.css';

export type LogCollectionDialogMode = 'capturing' | 'collecting';

export interface LogCollectionDialogProps {
	isOpen: boolean;
	mode: LogCollectionDialogMode | null;
	onStop: () => void;
	onCancel: () => void;
}

export const LogCollectionDialog: React.FC<LogCollectionDialogProps> = ({
	isOpen,
	mode,
	onStop,
	onCancel,
}) => {
	const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);

	if (!isOpen || !mode) return null;

	const isCapturing = mode === 'capturing';

	const handleCancelClick = () => {
		setShowCancelConfirmation(true);
	};

	const handleGoBack = () => {
		setShowCancelConfirmation(false);
	};

	const handleConfirmCancel = () => {
		setShowCancelConfirmation(false);
		onCancel();
	};

	return (
		<div className="log-dialog-backdrop" role="dialog" aria-modal="true">
			<div className="log-dialog-container">
				<div className="log-dialog-header">
					<span
						className="log-dialog-spinner"
						role="status"
						aria-label={LOG_COLLECTION_DIALOG_STRINGS.LOADING}
					/>
					<h2 className="log-dialog-title">
						{isCapturing
							? LOG_COLLECTION_DIALOG_STRINGS.CAPTURING_ISSUES
							: LOG_COLLECTION_DIALOG_STRINGS.COLLECTING_LOGS}
					</h2>
				</div>

				{isCapturing && (
					<>
						<p className="log-dialog-description">
							{LOG_COLLECTION_DIALOG_STRINGS.CAPTURING_DESCRIPTION}
						</p>
						<div className="log-dialog-footer">
							<PrimaryButton
								onClick={onStop}
								ariaLabel={LOG_COLLECTION_DIALOG_STRINGS.STOP}
							>
								{LOG_COLLECTION_DIALOG_STRINGS.STOP}
							</PrimaryButton>
							<SecondaryButton
								onClick={handleCancelClick}
								ariaLabel={LOG_COLLECTION_DIALOG_STRINGS.CANCEL}
							>
								{LOG_COLLECTION_DIALOG_STRINGS.CANCEL}
							</SecondaryButton>
						</div>
					</>
				)}

				{showCancelConfirmation && (
					<div className="log-dialog-cancel-flyover">
						<WarningAlertIcon
							width={20}
							height={20}
							className="log-dialog-cancel-warning-icon"
						/>
						<span className="log-dialog-cancel-text">
							{LOG_COLLECTION_DIALOG_STRINGS.CANCEL_CONFIRMATION_TITLE}{' '}
							{LOG_COLLECTION_DIALOG_STRINGS.CANCEL_CONFIRMATION_DESCRIPTION}
						</span>
						<div className="log-dialog-cancel-actions">
							<PrimaryButton
								onClick={handleConfirmCancel}
								ariaLabel={LOG_COLLECTION_DIALOG_STRINGS.CANCEL}
							>
								{LOG_COLLECTION_DIALOG_STRINGS.CANCEL}
							</PrimaryButton>
							<SecondaryButton
								onClick={handleGoBack}
								ariaLabel={LOG_COLLECTION_DIALOG_STRINGS.GO_BACK}
							>
								{LOG_COLLECTION_DIALOG_STRINGS.GO_BACK}
							</SecondaryButton>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
